import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ZelleComponent } from "./zelle.component";

@NgModule({
  declarations: [ZelleComponent],
  imports: [CommonModule],
  exports: [ZelleComponent],
})
export class ZelleModule {}
